import Vue from 'vue';
import App from './App';
import RouterConfig from './router';
import StoreConfig from './store';

import Fundation from 'fundation-app-vuejs';
Vue.use(Fundation);

import {Router, Store} from 'fundation-app-vuejs';

import 'material-design-icons-iconfont/dist/material-design-icons.css';

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
    icons:{
        iconfont: 'mdiSvg',
    },
    theme: {
        dark: true,
    }
};

import EventBus from './eventBus.js';
import Helpers from './components/Partials/helper.js';
Vue.prototype.$eventBus = EventBus;
Vue.prototype.$helpers = Helpers;

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

import i18n from './i18n';

// StoreConfig.metaDefinition = metaDefinition;
StoreConfig.apiRootUrl = window.config.api_root_url;

Vue.config.productionTip = false;

/* eslint-disable no-new */
let app = new Vue({
    el: '#app',
    router: new Router(RouterConfig),
    store: new Store(StoreConfig),
    components: { App },
    template: '<App/>',
    i18n,
    vuetify: new Vuetify(opts),
    created() {
        i18n.locale = this.$store.state.currentLocaleValue;
    },
    mounted (){
        let actionsToWatchForCreateLog = this.$store.getters.actionsToWatchForCreateLog;
        this.$store.subscribeAction((action) => {
            if(actionsToWatchForCreateLog.includes(action.type) && action.payload.model !== 'logUserActions'){
                this.$store.dispatch('createLog', {
                    origin: this.$route.name,
                    payload: action.payload,
                    actionType: action.type
                });
            }
        });
    }
});

let loading1 = document.querySelector('#loading1');
loading1.parentNode.removeChild(loading1);

window.app = app;



// WEBPACK FOOTER //
// ./src/main.js